/* Core */
import { createAsyncThunk } from '@reduxjs/toolkit';

/* Instruments */
import type { ReduxState, ReduxDispatch } from './store';

/**
 * 用于创建类型化异步 Thunk 操作的实用函数。
 */
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: ReduxState;
  dispatch: ReduxDispatch;
  rejectValue: string;
}>();
